import classnames from 'classnames';
import React, { FunctionComponent } from 'react';
import styles from './DonationAmountSelector.scss';

export type SuggestedAmountRadioButtonProps = {
  id: string;
  labelText: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const SuggestedAmountRadioButton: FunctionComponent<SuggestedAmountRadioButtonProps> = ({
  id,
  labelText,
  checked,
  onChange,
}) => {
  return (
    <li className={styles.amountSelectorListItem}>
      <label className="jg-form-radio-btn">
        <input
          data-qa={`donationAmountRadio_${id}`}
          className={classnames(
            'jg-form-radio-btn__input',
            styles.styledRadioButton,
          )}
          type="radio"
          name="donationAmount"
          id={id}
          checked={checked}
          onChange={onChange}
        />
        <span
          className={classnames(
            'jg-form-radio-btn__text',
            styles.amountSelectorLabel,
          )}
        >
          {labelText}
        </span>
      </label>
    </li>
  );
};
